import {makeStyles} from "@material-ui/core/styles";
import React, {useState} from "react";
import dashboardStyle from "../../../assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import loginPageStyle from "../../../assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import inputStyles from "../../../assets/jss/material-dashboard-pro-react/components/customInputStyle";
import Card from "../../../components/Card/Card";
import CardHeader from "../../../components/Card/CardHeader";
import CardBody from "../../../components/Card/CardBody";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Button from "../../../components/CustomButtons/Button";

var defaultPickerStyles = {
    ...dashboardStyle,
    ...loginPageStyle,
    ...inputStyles,
    cardTitle: {
        marginTop: "0",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const useDefaultPickerStyles = makeStyles(defaultPickerStyles);

export default function DefaultCandidatePicker({onSubmit}){
    const [candidateId, setCandidateId] = useState("");
    const classes = useDefaultPickerStyles();
    let validCandidateId = false;
    if (candidateId.length === 18) validCandidateId = true;
    if (candidateId.substring(0,82) === "https://gulp-switch.lightning.force.com/lightning/r/cxsrec__cxsCandidate__c/") validCandidateId = true;

    const submit = () => {
        let _candidateId = candidateId
        if (candidateId.substring(0,82) === "https://gulp-switch.lightning.force.com/lightning/r/cxsrec__cxsCandidate__c/"){
            _candidateId = candidateId.substring(80,100)
        };
        onSubmit();
        window.open(window.location.pathname + "?candidateId=" + _candidateId, "_self");
    }
    return (
        <Card>
            <CardHeader>
                <h4 className={classes.cardTitle}>Bewerbungs-ID erforderlich</h4>
                <p>Bitte gebe die Salesforce-ID Deines Kandidaten ein.</p>
                <p>Alternativ kannst Du auch den Link zu deinem Kandidaten in Salesforce eingeben.</p>
                <p><strong>Beispiele:</strong></p>
                <p>Salesforce-ID: <br/><code>a0A3X00002cJD9eUAG</code></p>
                <p>Salesforce-Link: <br/><code><code>https://gulp-switch.lightning.force.com/lightning/r/cxsrec__cxsCandidate__c/a0A3X00002cJD9eUAG/view</code></code></p>
            </CardHeader>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12} md={6}>
                        <CustomInput
                            id="candidateId"
                            labelText="Kandidaten-ID oder Salesforce-Link"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: e => setCandidateId(e.target.value),
                                value: candidateId
                            }}
                        />
                    </GridItem>
                </GridContainer>

                {validCandidateId && <Button color="primary" onClick={ () => submit() }>
                    weiter
                </Button>}
            </CardBody>
        </Card>
    )
}